const LANGUAGES: any = {
    "en": "English",
    "ru": "Russian",
    "fr": "French",
    "zh": "Chinese",
    "af": "Afrikaans",
    "sq": "Albanian",
    "am": "Amharic",
    "ar": "Arabic",
    "hy": "Armenian",
    "as": "Assamese",
    "ay": "Aymara",
    "az": "Azerbaijani",
    "bm": "Bambara",
    "eu": "Basque",
    "be": "Belarusian",
    "bn": "Bengali",
    "bho": "Bhojpuri",
    "bs": "Bosnian",
    "bg": "Bulgarian",
    "ca": "Catalan",
    "ceb": "Cebuano",
    "co": "Corsican",
    "hr": "Croatian",
    "cs": "Czech",
    "da": "Danish",
    "dv": "Dhivehi",
    "doi": "Dogri",
    "nl": "Dutch",
    "eo": "Esperanto",
    "et": "Estonian",
    "ee": "Ewe",
    "fil": "Filipino (Tagalog)",
    "fi": "Finnish",
    "fy": "Frisian",
    "gl": "Galician",
    "ka": "Georgian",
    "de": "German",
    "el": "Greek",
    "gn": "Guarani",
    "gu": "Gujarati",
    "ht": "Haitian Creole",
    "ha": "Hausa",
    "haw": "Hawaiian",
    "he": "Hebrew",
    "hi": "Hindi",
    "hmn": "Hmong",
    "hu": "Hungarian",
    "is": "Icelandic",
    "ig": "Igbo",
    "ilo": "Ilocano",
    "id": "Indonesian",
    "ga": "Irish",
    "it": "Italian",
    "ja": "Japanese",
    "jv": "Javanese",
    "kn": "Kannada",
    "kk": "Kazakh",
    "km": "Khmer",
    "rw": "Kinyarwanda",
    "gom": "Konkani",
    "ko": "Korean",
    "kri": "Krio",
    "ku": "Kurdish",
    "ckb": "Kurdish (Sorani)",
    "ky": "Kyrgyz",
    "lo": "Lao",
    "la": "Latin",
    "lv": "Latvian",
    "ln": "Lingala",
    "lt": "Lithuanian",
    "lg": "Luganda",
    "lb": "Luxembourgish",
    "mk": "Macedonian",
    "mai": "Maithili",
    "mg": "Malagasy",
    "ms": "Malay",
    "ml": "Malayalam",
    "mt": "Maltese",
    "mi": "Maori",
    "mr": "Marathi",
    "mni": "Meiteilon (Manipuri)",
    "lus": "Mizo",
    "mn": "Mongolian",
    "my": "Myanmar (Burmese)",
    "ne": "Nepali",
    "no": "Norwegian",
    "ny": "Nyanja (Chichewa)",
    "or": "Odia (Oriya)",
    "om": "Oromo",
    "ps": "Pashto",
    "fa": "Persian",
    "pl": "Polish",
    "pt": "Portuguese (Portugal, Brazil)",
    "pa": "Punjabi",
    "qu": "Quechua",
    "ro": "Romanian",
    "sm": "Samoan",
    "sa": "Sanskrit",
    "gd": "Scots Gaelic",
    "nso": "Sepedi",
    "sr": "Serbian",
    "st": "Sesotho",
    "sn": "Shona",
    "sd": "Sindhi",
    "si": "Sinhala (Sinhalese)",
    "sk": "Slovak",
    "sl": "Slovenian",
    "so": "Somali",
    "es": "Spanish",
    "su": "Sundanese",
    "sw": "Swahili",
    "sv": "Swedish",
    "tl": "Tagalog (Filipino)",
    "tg": "Tajik",
    "ta": "Tamil",
    "tt": "Tatar",
    "te": "Telugu",
    "th": "Thai",
    "ti": "Tigrinya",
    "ts": "Tsonga",
    "tr": "Turkish",
    "tk": "Turkmen",
    "ak": "Twi (Akan)",
    "uk": "Ukrainian",
    "ur": "Urdu",
    "ug": "Uyghur",
    "uz": "Uzbek",
    "vi": "Vietnamese",
    "cy": "Welsh",
    "xh": "Xhosa",
    "yi": "Yiddish",
    "yo": "Yoruba",
    "zu": "Zulu"
};

const clientLanguage: any = {
    "ru-RU": "Russian (Russia)",
    "en-US": "English (United States)",
    "af-ZA": "Afrikaans (South Africa)",
    "sq-AL": "Albanian (Albania)",
    "am-ET": "Amharic (Ethiopia)",
    "ar-DZ": "Arabic (Algeria)",
    "ar-BH": "Arabic (Bahrain)",
    "ar-EG": "Arabic (Egypt)",
    "ar-IQ": "Arabic (Iraq)",
    "ar-IL": "Arabic (Israel)",
    "ar-JO": "Arabic (Jordan)",
    "ar-KW": "Arabic (Kuwait)",
    "ar-LB": "Arabic (Lebanon)",
    "ar-MR": "Arabic (Mauritania)",
    "ar-MA": "Arabic (Morocco)",
    "ar-OM": "Arabic (Oman)",
    "ar-QA": "Arabic (Qatar)",
    "ar-SA": "Arabic (Saudi Arabia)",
    "ar-PS": "Arabic (State of Palestine)",
    "ar-TN": "Arabic (Tunisia)",
    "ar-AE": "Arabic (United Arab Emirates)",
    "ar-YE": "Arabic (Yemen)",
    "hy-AM": "Armenian (Armenia)",
    "az-AZ": "Azerbaijani (Azerbaijan)",
    "eu-ES": "Basque (Spain)",
    "bn-BD": "Bengali (Bangladesh)",
    "bn-IN": "Bengali (India)",
    "bs-BA": "Bosnian (Bosnia and Herzegovina)",
    "bg-BG": "Bulgarian (Bulgaria)",
    "my-MM": "Burmese (Myanmar)",
    "ca-ES": "Catalan (Spain)",
    "yue-Hant-HK": "Chinese, Cantonese (Traditional, Hong Kong)",
    "zh (cmn-Hans-CN)": "Chinese, Mandarin (Simplified, China)",
    "zh-TW (cmn-Hant-TW)": "Chinese, Mandarin (Traditional, Taiwan)",
    "hr-HR": "Croatian (Croatia)",
    "cs-CZ": "Czech (Czech Republic)",
    "da-DK": "Danish (Denmark)",
    "nl-BE": "Dutch (Belgium)",
    "nl-NL": "Dutch (Netherlands)",
    "en-AU": "English (Australia)",
    "en-CA": "English (Canada)",
    "en-GH": "English (Ghana)",
    "en-HK": "English (Hong Kong)",
    "en-IN": "English (India)",
    "en-IE": "English (Ireland)",
    "en-KE": "English (Kenya)",
    "en-NZ": "English (New Zealand)",
    "en-NG": "English (Nigeria)",
    "en-PK": "English (Pakistan)",
    "en-PH": "English (Philippines)",
    "en-SG": "English (Singapore)",
    "en-ZA": "English (South Africa)",
    "en-TZ": "English (Tanzania)",
    "en-GB": "English (United Kingdom)",
    "et-EE": "Estonian (Estonia)",
    "fil-PH": "Filipino (Philippines)",
    "fi-FI": "Finnish (Finland)",
    "fr-BE": "French (Belgium)",
    "fr-CA": "French (Canada)",
    "fr-FR": "French (France)",
    "fr-CH": "French (Switzerland)",
    "gl-ES": "Galician (Spain)",
    "ka-GE": "Georgian (Georgia)",
    "de-AT": "German (Austria)",
    "de-DE": "German (Germany)",
    "de-CH": "German (Switzerland)",
    "el-GR": "Greek (Greece)",
    "gu-IN": "Gujarati (India)",
    "iw-IL": "Hebrew (Israel)",
    "hi-IN": "Hindi (India)",
    "hu-HU": "Hungarian (Hungary)",
    "is-IS": "Icelandic (Iceland)",
    "id-ID": "Indonesian (Indonesia)",
    "it-IT": "Italian (Italy)",
    "it-CH": "Italian (Switzerland)",
    "ja-JP": "Japanese (Japan)",
    "jv-ID": "Javanese (Indonesia)",
    "kn-IN": "Kannada (India)",
    "kk-KZ": "Kazakh (Kazakhstan)",
    "km-KH": "Khmer (Cambodia)",
    "ko-KR": "Korean (South Korea)",
    "lo-LA": "Lao (Laos)",
    "lv-LV": "Latvian (Latvia)",
    "lt-LT": "Lithuanian (Lithuania)",
    "mk-MK": "Macedonian (North Macedonia)",
    "ms-MY": "Malay (Malaysia)",
    "ml-IN": "Malayalam (India)",
    "mr-IN": "Marathi (India)",
    "mn-MN": "Mongolian (Mongolia)",
    "ne-NP": "Nepali (Nepal)",
    "no-NO": "Norwegian Bokmål (Norway)",
    "fa-IR": "Persian (Iran)",
    "pl-PL": "Polish (Poland)",
    "pt-BR": "Portuguese (Brazil)",
    "pt-PT": "Portuguese (Portugal)",
    "pa-Guru-IN": "Punjabi (Gurmukhi, India)",
    "ro-RO": "Romanian (Romania)",
    "rw-RW": "Kinyarwanda (Rwanda)",
    "sr-RS": "Serbian (Serbia)",
    "si-LK": "Sinhala (Sri Lanka)",
    "sk-SK": "Slovak (Slovakia)",
    "sl-SI": "Slovenian (Slovenia)",
    "ss-latn-ZA": "Swati (South Africa)",
    "st-ZA": "Southern Sotho (South Africa)",
    "es-AR": "Spanish (Argentina)",
    "es-BO": "Spanish (Bolivia)",
    "es-CL": "Spanish (Chile)",
    "es-CO": "Spanish (Colombia)",
    "es-CR": "Spanish (Costa Rica)",
    "es-DO": "Spanish (Dominican Republic)",
    "es-EC": "Spanish (Ecuador)",
    "es-SV": "Spanish (El Salvador)",
    "es-GT": "Spanish (Guatemala)",
    "es-HN": "Spanish (Honduras)",
    "es-MX": "Spanish (Mexico)",
    "es-NI": "Spanish (Nicaragua)",
    "es-PA": "Spanish (Panama)",
    "es-PY": "Spanish (Paraguay)",
    "es-PE": "Spanish (Peru)",
    "es-PR": "Spanish (Puerto Rico)",
    "es-ES": "Spanish (Spain)",
    "es-US": "Spanish (United States)",
    "es-UY": "Spanish (Uruguay)",
    "es-VE": "Spanish (Venezuela)",
    "su-ID": "Sundanese (Indonesia)",
    "sw-KE": "Swahili (Kenya)",
    "sw-TZ": "Swahili (Tanzania)",
    "sv-SE": "Swedish (Sweden)",
    "ta-IN": "Tamil (India)",
    "ta-MY": "Tamil (Malaysia)",
    "ta-SG": "Tamil (Singapore)",
    "ta-LK": "Tamil (Sri Lanka)",
    "te-IN": "Telugu (India)",
    "th-TH": "Thai (Thailand)",
    "tn-latn-ZA": "Setswana (South Africa)",
    "tr-TR": "Turkish (Turkey)",
    "ts-ZA": "Tsonga (South Africa)",
    "uk-UA": "Ukrainian (Ukraine)",
    "ur-IN": "Urdu (India)",
    "ur-PK": "Urdu (Pakistan)",
    "uz-UZ": "Uzbek (Uzbekistan)",
    "ve-ZA": "Venda (South Africa)",
    "vi-VN": "Vietnamese (Vietnam)",
    "xh-ZA": "isiXhosa (South Africa)",
    "zu-ZA": "Zulu (South Africa)"
}


export const languageOptions = Object.keys(LANGUAGES).map(key => ({
    value: key,
    label: LANGUAGES[key]
}));

export const clientLanguageOptions = Object.keys(clientLanguage).map(key => ({
    value: key,
    label: clientLanguage[key]
}));

export const getClientLangByCode = (lang: string) => {
    const matchingLanguages = Object.keys(clientLanguage).filter(key => key.startsWith(lang));
    return matchingLanguages.length > 0 ? matchingLanguages[0] : 'en-US';
  }